const FOOTER_LINKS = [
  { label: "tradesense.ma", href: "https://tradesense.ma" },
  { label: "portnet.ma", href: "https://portnet.ma" },
  { label: "pkpi.portnet.ma", href: "https://pkpi.portnet.ma" },
  { label: "reclamation.portnet.ma", href: "https://reclamation.portnet.ma" },
];

const footerStyle = {
  height: "30px",
  minHeight: "30px",
  backgroundColor: "#25384A",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  flexShrink: 0,
  boxSizing: "border-box",
  padding: "0 12px",
  width: "100%",
};

const linkStyle = {
  color: "#ffffff",
  fontSize: "12px",
  textDecoration: "none",
};

const separatorStyle = {
  color: "rgba(255,255,255,0.45)",
  fontSize: "12px",
  userSelect: "none",
};

function InstitutionalFooter() {
  return (
    <footer style={footerStyle} aria-label="Liens institutionnels">
      {FOOTER_LINKS.map((item, index) => (
        <span
          key={item.href}
          style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}
        >
          {index > 0 ? <span style={separatorStyle}>|</span> : null}
          <a
            href={item.href}
            style={linkStyle}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.label}
          </a>
        </span>
      ))}
    </footer>
  );
}

export default InstitutionalFooter;
